import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { MVVMToolbar } from "../../Common/MVVMToolbar";
import { LoadScreen } from "../../Common/LoadScreen";

import { ProductDisplay } from "../../Products/UI/ProductDisplay";

export class OrderItemTable extends React.Component {
  getProductColumns = () => {
    let allColumns = [];
    let columns = this.props.productTableColumns.map((col, i) => {
      return (
        <pr.Column
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          filter={col.filter}
          filterMatchMode={col.filterMatchMode}
          style={col.style}
        />
      );
    });
    columns.push(
      <pr.Column
        field="quantity"
        editor={this.productQuantityEditor}
        header="Quantity"
        sortable={true}
        filter={true}
        style={{ overflow: "auto" }}
      />
    );
    if (this.props.editedObject.shipTogether !== true) {
      columns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getProductShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    }
    columns.push(
      <pr.Column
        key="add"
        field="manufactureTogether"
        header="Manufacture Together?"
        body={this.getProductManTemplate}
        style={{ textAlign: "center", width: "8em" }}
      />
    );

    columns.push(
      <pr.Column
        key="add"
        body={this.getProductAddTemplate}
        style={{ textAlign: "center", width: "8em" }}
      />
    );
    allColumns.push(pr.getExpanderColumn());
    columns.forEach(e => {
      allColumns.push(e);
    });

    return allColumns;
  };

  getOrderItemColumns = () => {
    let flaggedColumns = [];
    if (this.props.editedObject.shipTogether !== true) {
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getProductOrderShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="manufactureTogether"
          header="Manufacture Together?"
          body={this.getProductOrderManTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    } else {
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="manufactureTogether"
          header="Manufacture Together?"
          body={this.getProductOrderManTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    }

    return flaggedColumns;
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <div>
            <pr.Dialog
              visible={this.props.productAddModal}
              style={{ width: "100vw" }}
              modal={false}
              onHide={e => this.props.hideProductEditor()}
              header="Select Products"
              blockScroll={true}
              maximizable={true}
            >
              <div className="c-dialog-overflow">
                {/* {this.partSelectionTable()} */}
                <pr.DataTable
                  ref={el => {
                    this.dt = el;
                  }}
                  reorderableColumns={false}
                  selectionMode="single"
                  onSelectionChange={e => {}}
                  value={this.props.productList}
                  expandedRows={this.props.productExpandedRows}
                  onRowToggle={e =>
                    this.props.updateState("productExpandedRows", e.data)
                  }
                  rowExpansionTemplate={this.getProductSelectionView}
                  dataKey="id"
                  emptyMessage="No Products"
                  rows={100}
                  autoLayout={true}
                  paginator={true}
                  alwaysShowPaginator={true}
                >
                  {this.getProductColumns()}
                </pr.DataTable>{" "}
              </div>
            </pr.Dialog>
          </div>
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={e => {}}
            header={
              <div className="ui-g">
                <div className="ui-g-12" style={{ float: "right" }}>
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-plus"
                    label={"Add Item"}
                    onClick={() => {
                      this.props.updateState("productAddModal", true);
                    }}
                    style={{
                      marginRight: ".25em",
                      float: "right",
                      backgroundColor: "#043066"
                    }}
                  />
                </div>
              </div>
            }
            value={this.props.editedObject.orderItemList}
            dataKey="id"
            emptyMessage="This order contains no Products"
            rows={100}
            autoLayout={true}
          >
            <pr.Column
              field="productName"
              header="Name"
              style={{ overflow: "auto", backgroundColor: "white" }}
            />
            <pr.Column
              field="productDescription"
              header="Description"
              style={{ overflow: "auto", backgroundColor: "white" }}
            />

            <pr.Column
              field="status"
              header="Status"
              style={{ overflow: "auto", backgroundColor: "white" }}
            />
            {!this.props.disabled ? (
              <pr.Column
                field="quantity"
                header="Quantity"
                editor={this.productOrderQuantityEditor}
                style={{ overflow: "auto", backgroundColor: "white" }}
              />
            ) : (
              <pr.Column
                field="quantity"
                header="Quantity"
                style={{ overflow: "auto", backgroundColor: "white" }}
              />
            )}
            {this.getOrderItemColumns()}
            {!this.props.disabled && (
              <pr.Column
                key="add"
                body={this.getProductRemoveTemplate}
                style={{ textAlign: "center", width: "8em" }}
              />
            )}
          </pr.DataTable>
        </div>
      </React.Fragment>
    );
  }

  getProductSelectionView = data => {
    return <ProductDisplay data={data} />;
  };

  productQuantityEditor = props => {
    return this.productInputTextEditor(props, "quantity");
  };
  productOrderQuantityEditor = props => {
    return this.productOrderInputTextEditor(props, "quantity");
  };

  getProductManTemplate = rowData => {
    return (
      <pr.Dropdown
        value={rowData.manufactureTogether}
        options={[
          { label: "Yes", value: true },
          { label: "No", value: false }
        ]}
        onChange={e => {
          if (!this.props.disabled) {
            this.onProductBodyValueChange(
              rowData.id,
              "manufactureTogether",
              e.value
            );
          }
        }}
        disabled={this.props.disabled}
        style={{ width: "100%" }}
      />
      // <pr.TriStateCheckbox
      //   onLabel="Yes"
      //   offLabel="No"
      //   value={rowData.manufactureTogether}
      //   onChange={e => {
      //     if (!this.props.disabled) {
      //       this.onProductBodyValueChange(
      //         rowData.id,
      //         "manufactureTogether",
      //         e.value
      //       );
      //     }
      //   }}
      // />
    );
  };
  getProductShipTemplate = rowData => {
    return (
      <div>
        <pr.Dropdown
          value={rowData.shipTogether}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false }
          ]}
          onChange={e => {
            if (!this.props.disabled) {
              this.onProductBodyValueChange(
                rowData.id,
                "shipTogether",
                e.value
              );
            }
          }}
          disabled={this.props.disabled}
          style={{ width: "100%" }}
        />
        {/* <pr.TriStateCheckbox
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
          onChange={e => {
            if (!this.props.disabled) {
              this.onProductBodyValueChange(
                rowData.id,
                "shipTogether",
                e.value
              );
            }
          }}
        /> */}
      </div>
    );
  };
  getProductOrderManTemplate = rowData => {
    return (
      <pr.Dropdown
        value={rowData.manufactureTogether}
        options={[
          { label: "Yes", value: true },
          { label: "No", value: false }
        ]}
        onChange={e => {
          if (!this.props.disabled) {
            this.onProductOrderBodyValueChange(
              rowData.id,
              "manufactureTogether",
              e.value
            );
          }
        }}
        disabled={this.props.disabled}
        style={{ width: "100%" }}
      />
      // <pr.TriStateCheckbox
      //   onLabel="Yes"
      //   offLabel="No"
      //   value={rowData.manufactureTogether}
      //   onChange={e => {
      //     if (!this.props.disabled) {
      //       this.onProductOrderBodyValueChange(
      //         rowData.id,
      //         "manufactureTogether",
      //         e.value
      //       );
      //     }
      //   }}
      // />
    );
  };
  getProductOrderShipTemplate = rowData => {
    return (
      <div>
        <pr.Dropdown
          value={rowData.shipTogether}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false }
          ]}
          onChange={e => {
            if (!this.props.disabled) {
              this.onProductOrderBodyValueChange(
                rowData.id,
                "shipTogether",
                e.value
              );
            }
          }}
          disabled={this.props.disabled}
          style={{ width: "100%" }}
        />
        {/* <pr.TriStateCheckbox
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
          onChange={e => {
            if (!this.props.disabled) {
              this.onProductOrderBodyValueChange(
                rowData.id,
                "shipTogether",
                e.value
              );
            }
          }}
        /> */}
      </div>
    );
  };
  getProductAddTemplate = (rowData, column) => {
    if (
      rowData.quantity === 0 ||
      rowData.quantity === undefined ||
      rowData.quantty === ""
    ) {
      return <div></div>;
    } else {
      if (rowData.quantityAdded) {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-check"
              className="p-button-success"
              onClick={() => {}}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em", background: "green" }}
            ></pr.Button>
          </div>
        );
      } else {
        return (
          <div>
            <pr.Button
              type="button"
              icon="pi pi-plus"
              className="p-button-success"
              onClick={f => this.props.updateProductSelected(f, rowData)}
              // onClick={() => {
              //   this.setState({ partSelected: rowData, partAdded: true });
              // }}
              style={{ marginRight: ".5em" }}
            ></pr.Button>
          </div>
        );
      }
    }
  };

  getProductRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.props.removeProductFromSelectedProducts(rowData);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };
  onProductEditorValueChange = (row, field, value) => {
    let updatedList = this.props.productList;
    updatedList[row][field] = value;

    this.props.updateState("productLst", updatedList);
  };
  onProductBodyValueChange = (row, field, value) => {
    let updatedList = this.props.productList;
    updatedList.forEach(element => {
      if (element.id === row) {
        element[field] = value;
      }
    });

    this.props.updateState("productLst", updatedList);
  };
  onProductOrderBodyValueChange = (row, field, value) => {
    let updatedList = this.props.editedObject.orderItemList;
    updatedList.forEach(element => {
      if (element.id === row) {
        element[field] = value;
      }
    });

    this.props.updateValue("orderItemList", updatedList);
  };
  onProductOrderEditorValueChange = (row, field, value) => {
    let updatedList = this.props.editedObject.orderItemList;
    updatedList[row][field] = value;

    if (format.isNotNull(value)) {
      var orderItem = format.deepCopy(updatedList[row]);
      var partProductJson = JSON.parse(orderItem.partProductJson);
      if (format.isNotNull(partProductJson.products)) {
        partProductJson.products.forEach(element => {
          element.quantity = parseInt(orderItem.quantity, 10).toString();
        });
      }
      orderItem.partProductJson = JSON.stringify(partProductJson);
      updatedList[row] = orderItem;
    }

    this.props.updateValue("orderItemList", updatedList);
  };

  productInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        keyfilter="int"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onProductEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  productOrderInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        keyfilter="int"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onProductOrderEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Orders/UI/OrderItemTable.js